import React from 'react';
import Icon from '../../../components/AppIcon';

const MILESTONES = [
  {
    year: '2019',
    title: 'The royal vision',
    icon: 'Sparkles',
    description:
      'Founded to fix what Indian online gaming kept getting wrong — slow payouts, silent support and games nobody could verify.',
  },
  {
    year: '2020',
    title: 'Trust foundation',
    icon: 'ShieldCheck',
    description:
      'Payment partnerships signed and gaming licences secured, so every rupee that moves through Nitin Online Book is traceable and protected.',
  },
  {
    year: '2021',
    title: 'Community growth',
    icon: 'Users',
    description:
      '10,000+ active players, almost entirely through word of mouth. No aggressive ads — just people telling friends the payouts really are that fast.',
  },
  {
    year: '2022',
    title: 'Innovation leader',
    icon: 'MessageCircle',
    description:
      "India's first WhatsApp-integrated gaming desk: login help, sign up, app download and cashier support in the app people already use.",
  },
  {
    year: '2023',
    title: 'Industry recognition',
    icon: 'Award',
    description:
      "Awarded 'Best Customer Service' and 'Most Trusted Platform' by the Indian Gaming Association, judged on response times and dispute records.",
  },
  {
    year: '2026',
    title: 'Royal legacy',
    icon: 'Crown',
    description:
      '50,000+ satisfied players and ₹100Cr+ in secure payouts — with the same two-minute reply promise we started with.',
  },
];

const BrandStorySection = () => (
  <section className="relative overflow-hidden py-24">
    <span className="aurora right-[-6%] top-[20%] h-96 w-96 bg-royal-violet/25" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <span className="badge-pill"><Icon name="BookOpen" size={13} /> Our story</span>
        <h2 className="mt-6 font-heading text-display font-bold text-white">
          Seven years, one <span className="gold-text">promise</span>
        </h2>
        <p className="mt-4 text-body-lg text-white/60">
          Nitin Online Book and Nitin Online Book grew slowly and deliberately. Here is exactly how, year by year.
        </p>
      </div>

      <div className="relative mt-16">
        {/* Spine */}
        <span className="absolute left-6 top-0 hidden h-full w-px bg-gradient-to-b from-transparent via-royal-gold/40 to-transparent lg:left-1/2 lg:block" aria-hidden="true" />

        <div className="space-y-8">
          {MILESTONES.map((m, i) => (
            <div
              key={m.year}
              className={`relative flex flex-col gap-6 lg:flex-row lg:items-center ${i % 2 ? 'lg:flex-row-reverse' : ''}`}
            >
              <div className="lg:w-1/2">
                <article className="card-3d p-7">
                  <div className="flex items-center gap-3">
                    <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-royal-gold/12">
                      <Icon name={m.icon} size={20} color="#F0C24B" />
                    </span>
                    <div>
                      <p className="font-display text-xs uppercase tracking-[0.2em] text-royal-gold">{m.year}</p>
                      <h3 className="font-heading text-xl font-bold text-white">{m.title}</h3>
                    </div>
                  </div>
                  <p className="mt-4 text-sm leading-relaxed text-white/55">{m.description}</p>
                </article>
              </div>

              {/* Node */}
              <span className="absolute left-4 top-8 hidden h-4 w-4 rounded-full border-2 border-[#06060C] bg-gradient-royal shadow-glow lg:left-1/2 lg:block lg:-translate-x-1/2" aria-hidden="true" />

              <div className="hidden lg:block lg:w-1/2" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default BrandStorySection;
